import React, { PureComponent, Fragment } from 'react'
import { Grid, ListItem, Paper, Button } from '@material-ui/core'
import NoteItem from './NoteItem'

export default class NoteList extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      notes: [],
      employeeId: '',
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.id && nextProps.data.id != this.state.employeeId) {
      this.setState({
        employeeId: nextProps.data.id,
        notes: nextProps.data.notes || [],
      })
    }
  }

  addNote = () => {
    this.state.notes.push({ message: '', modified: new Date().getTime() })
    this.setState({ notes: [...this.state.notes] })
  }

  onChange = (notes) => {
    this.setState({ notes })
  }

  onSave = () => {
    this.props.onChange('notes', [...this.state.notes])
  }

  render() {
    const { editMode = false, data = {} } = this.props
    return (
      <Fragment>
        <Paper className="paper-page">
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                Notes
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                {editMode ? (
                  <Button className="primary-button" onClick={this.addNote}>
                    Add Note
                  </Button>
                ) : null}
              </Grid>
            </Grid>
          </ListItem>
          {this.state.notes.length > 0
            ? this.state.notes.map((note, index) => (
                <NoteItem
                  key={index}
                  note={note}
                  parent={data}
                  notes={this.state.notes}
                  editMode={editMode}
                  index={index}
                  onSave={this.onSave}
                  onChange={this.onChange}
                />
              ))
            : null}
        </Paper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Notes/NoteList.js